<div>
  <input #input (focus)="selectText()" (keydown.enter)="onEnterKeyDown()" (keyup)="onKeyUp()" [(ngModel)]="value"/>

  @if (isRevertIconVisible) {
    <app-icon-backspace-outline
      (click)="onUndoChangesClick()">
    </app-icon-backspace-outline>
  }

</div>
